import React from 'react';

interface ErrorMessageProps {
    message: string;
    onRetry?: () => void;
    onDismiss?: () => void;
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({
    message,
    onRetry,
    onDismiss
}) => {
    return (
        <div className="error-container">
            <div className="error-content">
                <div className="error-icon">⚠️</div>
                <div className="error-text">
                    <h3 className="error-title">Verification Failed</h3>
                    <p className="error-message">{message}</p>
                </div>
            </div>

            <div className="error-actions">
                {onRetry && (
                    <button
                        className="retry-button"
                        onClick={onRetry}
                    >
                        Try Again
                    </button>
                )}

                {onDismiss && (
                    <button
                        className="dismiss-button"
                        onClick={onDismiss}
                    >
                        Dismiss
                    </button>
                )}

                {!onRetry && !onDismiss && (
                    <button
                        className="retry-button"
                        onClick={() => window.location.reload()}
                    >
                        Reload Page
                    </button>
                )}
            </div>
        </div>
    );
};

export default ErrorMessage;